<template>
  <td
    :class="{br: indexHasBorderRight(index)}"
  >
    <span
      v-if="value === null"
    >
      -
    </span>
    <span
      v-else-if="value === 0"
    >
      n.s.
    </span>
    <span
      v-else
    >
      {{ value | formatPrice }}
    </span>
  </td>
</template>

<script>
export default {
  name: 'GdtValueCell',
  props: {
    index: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  methods: {
    indexHasBorderRight(index) {
      return [1, 2, 3, 4].includes(index);
    },
  },
};
</script>
